<template>
  <h1>薬局設定</h1>
</template>

<script>
export default {
  name: "PharmacySetting",
};
</script>
